import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function InnovaCabBookingInShirdi() {



    const cardData = {





keyword: "Innova Cab Booking in Shirdi",

headingDescription: "Sai Shirdi Cab provides convenient Innova Cab Booking in Shirdi for families, devotees, tourists, corporate travelers, and groups looking for a spacious vehicle for outstation journeys from Shirdi. Customers can book an Innova with a professional driver for one-way trips, round trips, multi-day journeys, pilgrimage tours, family vacations, sightseeing, and business travel. The spacious cabin and luggage capacity make an Innova a practical choice for families and small groups traveling from Shirdi to nearby and long-distance destinations. Popular outstation routes include Nashik, Chhatrapati Sambhajinagar, Ahmednagar, Pune, Mumbai, Shani Shingnapur, Trimbakeshwar, Bhimashankar, Saptashrungi, Ajanta-Ellora, Goa, and Ujjain. Sai Shirdi Cab offers clean and well-maintained vehicles, experienced drivers, flexible pickup timings, and convenient door-to-door transportation. Customers can also combine multiple destinations into a single customized itinerary according to their travel plans.",

topPlaces: [
  {
    title: "Nashik",
    description: "Nashik is a popular outstation destination from Shirdi for pilgrimage, sightseeing, family trips, and business travel. Customers can book an Innova for a comfortable journey from Shirdi to Nashik, with convenient seating and luggage space for families and small groups. Trimbakeshwar can also be included in the same itinerary."
  },
  {
    title: "Chhatrapati Sambhajinagar",
    description: "Chhatrapati Sambhajinagar is an important outstation destination from Shirdi for heritage sightseeing, family travel, business visits, and religious tours. An Innova provides comfortable private transportation for passengers traveling together. Customers can choose one-way, round-trip, or customized multi-destination travel."
  },
  {
    title: "Ahmednagar",
    description: "Ahmednagar is a convenient destination from Shirdi for business travel, family visits, and personal journeys. Customers can book an Innova with a professional driver for direct or round-trip transportation. The spacious vehicle is suitable for families and groups requiring comfortable seating and luggage space."
  },
  {
    title: "Pune",
    description: "Pune is a major outstation destination from Shirdi for corporate work, family visits, education, medical travel, and tourism. Customers can book an Innova for direct transportation from Shirdi to Pune. The vehicle is a suitable option for families and groups looking for comfortable long-distance travel."
  },
  {
    title: "Mumbai",
    description: "Mumbai is a major long-distance destination from Shirdi for business, tourism, family travel, and airport-related journeys. Customers can book an Innova with a professional driver for convenient door-to-door transportation. One-way, round-trip, and multi-day bookings can be arranged according to the itinerary."
  },
  {
    title: "Shani Shingnapur",
    description: "Shani Shingnapur is a popular pilgrimage destination that can be covered from Shirdi by private Innova. Families and devotees can book a round-trip vehicle for comfortable temple travel. Customers can also combine Shani Shingnapur with other nearby religious destinations for a customized pilgrimage itinerary."
  },
  {
    title: "Trimbakeshwar",
    description: "Trimbakeshwar is a prominent Jyotirlinga destination that can be visited from Shirdi by Innova. Customers can plan a private pilgrimage covering Shirdi, Nashik, and Trimbakeshwar in one trip. The spacious vehicle is suitable for families and small groups traveling together."
  },
  {
    title: "Bhimashankar",
    description: "Bhimashankar is an important pilgrimage destination that can be included in an outstation journey from Shirdi. Customers can book an Innova for a comfortable round trip with flexible travel timings. The journey can be customized to include other religious or sightseeing destinations along the route."
  },
  {
    title: "Saptashrungi",
    description: "Saptashrungi Devi Temple at Vani is a popular pilgrimage destination from Shirdi. Customers can book an Innova for family and group travel to the temple, with comfortable seating and useful luggage space. The route can also be combined with Nashik and other nearby pilgrimage locations."
  },
  {
    title: "Ajanta-Ellora Caves",
    description: "Ajanta and Ellora Caves are popular heritage destinations that can be covered from Shirdi through a customized Innova cab trip. Customers can plan a full-day or multi-day sightseeing journey with convenient stops along the route. The vehicle is suitable for families and small groups carrying luggage."
  },
  {
    title: "Goa",
    description: "Goa is a popular long-distance holiday destination from Shirdi for families, groups, and leisure travelers. Customers can book an Innova for a multi-day journey with comfortable seating and sufficient luggage space. The trip can include hotel transfers, sightseeing, and return transportation."
  },
  {
    title: "Ujjain",
    description: "Ujjain is an important pilgrimage destination that can be included in a long-distance religious journey from Shirdi. Customers can book an Innova for comfortable family and group travel. The itinerary can also cover Indore and other nearby destinations as part of a customized multi-day trip."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a popular hill station for family holidays, weekend trips, and group travel from Shirdi. Customers can book an Innova with a professional driver for a comfortable outstation journey. Multi-day bookings can include sightseeing, hotel transfers, and nearby attractions."
  }
],







"services": [
{
"name": "Innova Cab Booking in Shirdi",
"description": "Innova Cab Booking in Shirdi provides a convenient private transportation option for families, groups, and travelers who require a spacious vehicle. The booking can be arranged for local travel, pilgrimage visits, sightseeing, airport transfers, railway station pickups, and outstation journeys."
},
{
"name": "Toyota Innova Cab Booking Shirdi",
"description": "Toyota Innova Cab Booking Shirdi offers comfortable transportation for passengers looking for additional seating and luggage space. Travelers can arrange the vehicle according to their preferred pickup location, travel date, passenger count, destination, and one-way or round-trip requirements."
},
{
"name": "Innova Taxi Booking Shirdi",
"description": "Innova Taxi Booking Shirdi allows travelers to reserve a spacious private taxi for planned journeys around Shirdi and nearby destinations. The booking can be organized according to passenger capacity, luggage requirements, travel timing, pickup point, destination, and preferred trip type."
},
{
"name": "Innova Cab Service Shirdi",
"description": "Innova Cab Service Shirdi provides private transportation for families, groups, tourists, and devotees traveling within Shirdi or toward other destinations. The cab can be arranged for temple visits, sightseeing, railway station transfers, airport travel, and outstation transportation."
},
{
"name": "Innova Taxi Service Shirdi",
"description": "Innova Taxi Service Shirdi offers a comfortable and spacious travel option for passengers requiring private transportation. Taxi arrangements can be planned according to passenger count, luggage, pickup timing, destination, travel schedule, and one-way or return journey needs."
},
{
"name": "Innova Car Rental Shirdi",
"description": "Innova Car Rental Shirdi provides a practical vehicle rental option for travelers planning local and long-distance journeys. Customers can arrange the car according to rental duration, passenger requirements, luggage capacity, route, pickup location, destination, and preferred itinerary."
},
{
"name": "Innova On Rent Shirdi",
"description": "Innova On Rent Shirdi offers spacious private transportation for families, groups, and travelers requiring a comfortable vehicle. The rental can be arranged for sightseeing, Sai Baba darshan, local travel, airport transfers, railway station pickups, and outstation trips."
},
{
"name": "Innova Cab on Rent Shirdi",
"description": "Innova Cab on Rent Shirdi provides a convenient cab rental solution for passengers traveling around Shirdi and to other cities. Vehicle arrangements can be planned according to passenger capacity, luggage requirements, travel duration, pickup point, destination, and selected journey type."
},
{
"name": "Innova Taxi on Rent Shirdi",
"description": "Innova Taxi on Rent Shirdi is suitable for travelers who need a spacious private taxi for family trips, pilgrimage travel, sightseeing, or outstation journeys. The service can be scheduled according to the required travel date, pickup location, passenger count, luggage, and destination."
},
{
"name": "Innova Booking Online Shirdi",
"description": "Innova Booking Online Shirdi allows travelers to arrange a spacious vehicle in advance for their planned transportation needs. Customers can provide pickup details, travel date, passenger count, luggage requirements, destination, journey type, and preferred travel schedule."
},
{
"name": "Innova Cab Booking Online Shirdi",
"description": "Innova Cab Booking Online Shirdi provides a convenient way to reserve private transportation before the journey. Booking arrangements can be organized for local travel, temple visits, sightseeing, airport transfers, railway station pickups, and outstation trips according to passenger requirements."
},
{
"name": "Innova One Way Cab Shirdi",
"description": "Innova One Way Cab Shirdi provides direct private transportation for passengers who require a single journey without a return booking. The cab can be arranged from the preferred pickup location in Shirdi to the selected destination with suitable seating and luggage capacity."
},
{
"name": "Innova Round Trip Cab Shirdi",
"description": "Innova Round Trip Cab Shirdi is suitable for families and groups planning an onward journey and return to Shirdi. The trip can be scheduled according to travel dates, stay duration, passenger count, waiting requirements, destination, and preferred return itinerary."
},
{
"name": "Innova Outstation Cab Shirdi",
"description": "Innova Outstation Cab Shirdi provides spacious private transportation for travelers planning long-distance journeys from Shirdi. The vehicle can be arranged for family trips, group travel, pilgrimage routes, sightseeing tours, one-way journeys, or round-trip transportation."
},
{
"name": "Innova Airport Cab Shirdi",
"description": "Innova Airport Cab Shirdi offers comfortable airport pickup and drop transportation for passengers traveling to or from airports near Shirdi. The cab can be coordinated with flight schedules and arranged according to luggage, passenger count, airport location, and final destination."
},
{
"name": "Innova Railway Station Cab Shirdi",
"description": "Innova Railway Station Cab Shirdi provides spacious transportation for passengers arriving at or departing from railway stations around Shirdi. Pickup and drop arrangements can be scheduled according to train timings, passenger requirements, luggage, preferred vehicle, and destination."
},
{
"name": "Innova Darshan Cab Shirdi",
"description": "Innova Darshan Cab Shirdi provides comfortable private transportation for devotees visiting Sai Baba Temple and other nearby pilgrimage destinations. The cab can be arranged for families and groups according to darshan schedules, passenger count, luggage, pickup location, and preferred travel itinerary."
},
{
"name": "Innova Sightseeing Cab Shirdi",
"description": "Innova Sightseeing Cab Shirdi is a spacious option for families and groups exploring Shirdi and nearby attractions. The cab can be arranged for local sightseeing, temple visits, nearby destinations, family outings, and customized tours with convenient pickup and drop arrangements."
},
{
"name": "Affordable Innova Cab Booking Shirdi",
"description": "Affordable Innova Cab Booking Shirdi provides a practical option for travelers seeking spacious private transportation while managing their travel budget. Booking plans can be selected according to journey type, passenger count, travel duration, luggage requirements, route, and vehicle usage."
},
{
"name": "Best Innova Taxi Service Shirdi",
"description": "Best Innova Taxi Service Shirdi offers spacious private transportation for families, tourists, devotees, and groups traveling around Shirdi or toward outstation destinations. Taxi arrangements can be customized according to pickup timing, passenger requirements, luggage, vehicle preference, and travel itinerary."
},
{
"name": "Sai Shirdi Cabs",
"description": "Sai Shirdi Cabs provides Innova and other suitable private vehicles for local travel, Sai Baba darshan, sightseeing, airport transfers, railway station pickups, family trips, and outstation journeys. Vehicle arrangements can be planned according to passenger count, luggage, travel schedule, and destination."
}
],
"tableData": [
["Innova Cab Booking in Shirdi", "Toyota Innova Cab Booking Shirdi"],
["Innova Taxi Booking Shirdi", "Innova Cab Service Shirdi"],
["Innova Taxi Service Shirdi", "Innova Car Rental Shirdi"],
["Innova On Rent Shirdi", "Innova Cab on Rent Shirdi"],
["Innova Taxi on Rent Shirdi", "Innova Booking Online Shirdi"],
["Innova Cab Booking Online Shirdi", "Innova One Way Cab Shirdi"],
["Innova Round Trip Cab Shirdi", "Innova Outstation Cab Shirdi"],
["Innova Airport Cab Shirdi", "Innova Railway Station Cab Shirdi"],
["Innova Darshan Cab Shirdi", "Innova Sightseeing Cab Shirdi"],
["Affordable Innova Cab Booking Shirdi", "Best Innova Taxi Service Shirdi"],
["Sai Shirdi Cabs", "Innova Cab Booking in Shirdi"]
]
,








    whychoose: [
        { 
            WhyChooseheading: "Innova Cab Booking in Shirdi for Comfortable Group Travel", 
            WhyChoosedescription: "Sai Shirdi Cabs provides Innova cab booking services in Shirdi for families, devotees, tourists, corporate travellers, and groups who need a spacious private vehicle. An Innova can be arranged for Sai Baba Darshan, Shirdi sightseeing, airport transfers, railway station pickups, hotel transfers, and outstation journeys based on your travel schedule." 
        }, 
        { 
            WhyChooseheading: "Spacious Cab for Family & Group Journeys", 
            WhyChoosedescription: "Innova is a practical option for families and small groups who want to travel together with passengers and luggage. The spacious cabin makes it suitable for local travel as well as longer journeys where additional comfort and seating space are important." 
        }, 
        { 
            WhyChooseheading: "Innova for Sai Baba Darshan", 
            WhyChoosedescription: "Devotees can book an Innova for transportation between their hotel, Sai Baba Temple, railway station, and nearby pilgrimage destinations. A private cab allows families and groups to follow their Darshan schedule without relying on shared transportation." 
        }, 
        { 
            WhyChooseheading: "Convenient Shirdi Sightseeing by Innova", 
            WhyChoosedescription: "Explore Shirdi and nearby attractions in a private Innova according to your preferred sightseeing plan. Multiple stops can be included based on your itinerary, available time, and travel requirements." 
        }, 
        { 
            WhyChooseheading: "Airport & Railway Station Transfers", 
            WhyChoosedescription: "Book an Innova for airport and railway station pickup or drop services in and around Shirdi. It is a suitable option for families and groups travelling with luggage who prefer a direct private transfer to their hotel or onward destination." 
        }, 
        { 
            WhyChooseheading: "One-Way & Round-Trip Innova Booking", 
            WhyChoosedescription: "Choose one-way Innova travel when you need direct transportation to another destination, or arrange a round-trip service when the vehicle is required for both onward and return journeys from Shirdi." 
        }, 
        { 
            WhyChooseheading: "Outstation & Multi-Day Innova Travel", 
            WhyChoosedescription: "Innova can be booked for outstation journeys from Shirdi to destinations such as Nashik, Mumbai, Pune, Aurangabad, Indore, Goa, and other cities or tourist locations. Multi-day travel can also be planned according to your itinerary and trip duration." 
        }, 
        { 
            WhyChooseheading: "Book Innova Cab in Shirdi with Sai Shirdi Cabs", 
            WhyChoosedescription: "Share your pickup location, destination, travel date, passenger count, luggage details, trip duration, one-way or round-trip requirement, and preferred travel schedule with Sai Shirdi Cabs to arrange a suitable Innova cab booking." 
        } 
    ] 

}; 

const faqData = [ 
    { 
        question: "Can I book an Innova cab in Shirdi?", 
        answer: "Yes, Sai Shirdi Cabs provides Innova cab booking services in Shirdi for Sai Baba Darshan, sightseeing, airport transfers, railway station travel, family trips, and outstation journeys." 
    }, 
    { 
        question: "Is Innova suitable for family travel in Shirdi?", 
        answer: "Yes, Innova is a spacious private vehicle option for families and small groups travelling with passengers and luggage, subject to the vehicle's seating and luggage capacity." 
    }, 
    { 
        question: "Can I book an Innova for Sai Baba Darshan?", 
        answer: "Yes, an Innova can be arranged for transportation between your hotel, Sai Baba Temple, railway station, and nearby pilgrimage destinations." 
    }, 
    { 
        question: "Can I book Innova for Shirdi sightseeing?", 
        answer: "Yes, a private Innova can be booked for Shirdi sightseeing and nearby attractions according to your preferred itinerary and travel schedule." 
    }, 
    { 
        question: "Can I book an Innova for airport pickup and drop?", 
        answer: "Yes, Innova cab service can be arranged for airport pickup and drop according to your flight schedule, passenger count, and luggage requirements." 
    }, 
    { 
        question: "Can I book Innova from Shirdi Railway Station?", 
        answer: "Yes, Innova can be arranged for railway station pickup or drop according to your train schedule, passenger count, and luggage requirements." 
    }, 
    { 
        question: "Can I book an Innova for a one-way trip from Shirdi?", 
        answer: "Yes, one-way Innova travel can be arranged for passengers who require direct transportation from Shirdi to another destination without needing the same vehicle for the return journey." 
    }, 
    { 
        question: "Can I book an Innova for outstation travel from Shirdi?", 
        answer: "Yes, Innova can be booked for outstation journeys from Shirdi to various cities, tourist destinations, and pilgrimage locations according to your travel plans." 
    }, 
    { 
        question: "Can I book an Innova for a multi-day trip?", 
        answer: "Yes, multi-day Innova arrangements can be discussed for extended sightseeing tours, pilgrimage journeys, family vacations, and multi-city travel from Shirdi." 
    }, 
    { 
        question: "How can I book an Innova Cab in Shirdi?", 
        answer: "Share your pickup point, destination, travel date, passenger count, luggage details, trip duration, and one-way or return requirement with Sai Shirdi Cabs to proceed with the Innova cab booking." 
    } 
]; 

const testimonials = [ 
    { 
        id: 1, 
        name: "Mr. Ajay More", 
        feedback: "We booked an Innova in Shirdi for our family pilgrimage and sightseeing trip. The spacious vehicle was convenient for our group and luggage, especially when travelling between several locations.", 
        rating: 5 
    }, 
    { 
        id: 2, 
        name: "Mrs. Pooja Patil", 
        feedback: "Our family needed a private cab for Shirdi Darshan and an outstation journey. We chose an Innova because everyone could travel together with our luggage, making the trip comfortable and convenient.", 
        rating: 5 
    } 
];








    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Cab Booking in Shirdi",
  "image": "https://www.saishirdicabs.com/assets/images/innova-cab-booking-in-shirdi.webp",
  "description":
    "Book an Innova Cab in Shirdi with Sai Shirdi Cabs for comfortable, spacious, and reliable local and outstation travel. Our Toyota Innova cab service is suitable for Sai Baba Darshan, Shirdi sightseeing, airport transfers, railway station transfers, family trips, one-way journeys, round trips, and outstation travel. Get a well-maintained Innova with a professional driver, convenient pickup and drop locations, affordable fares, and easy booking assistance.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/innova-cab-booking-in-shirdi"
  }
};





    return (
        <div>

<Helmet>
  <title>Innova Cab Booking in Shirdi | Innova Taxi Booking | +91 7776814559</title>

  <meta
    name="description"
    content="Book an Innova Cab in Shirdi with Sai Shirdi Cabs for Sai Baba Darshan, sightseeing, airport and railway station transfers, family trips, one-way, round trips and outstation travel. Get a comfortable Innova with professional driver and easy booking."
  />

  <meta
    name="keywords"
    content="Innova Cab Booking in Shirdi, Toyota Innova Cab Booking Shirdi, Innova taxi booking Shirdi, Innova cab service Shirdi, Innova taxi service Shirdi, Innova car rental Shirdi, Innova on rent Shirdi, Innova cab on rent Shirdi, Innova taxi on rent Shirdi, Innova booking online Shirdi, Innova cab booking online Shirdi, Innova one way cab Shirdi, Innova round trip cab Shirdi, Innova outstation cab Shirdi, Innova with driver Shirdi, Innova car hire Shirdi, Innova rental Shirdi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/80.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default InnovaCabBookingInShirdi;